

import { Component, Prop, Vue } from 'vue-facing-decorator';

// import { Feature } from '@iabtechlabtcf/core/GVL/Model/Feature';

// Feature type not exported (WTF???) so we have to define it here

type Feature = {
  id: number;
  name: string;
  description: string;
  descriptionLegal?: string;
  illustrations?: string[];
};

import ChevronIcon from '../icons/ChevronIcon.vue'
import { Vue3SlideUpDown } from "vue3-slide-up-down";

@Component({
  components: {
    ChevronIcon,
    Vue3SlideUpDown
  },
})

export default class FeatureItem extends Vue {
    
    expanded = false;
    collapseClass = "collapseButton collapseButtonRotatedUp"

    @Prop( { default:{ name:'none', id:0 } }) feature!: Feature;

    formattedDescriptions :string[] = [];

    mounted() : void {
      // console.log( "Feature " + this.feature.id + " " +this.feature.name );

    // @ts-ignore
      let model = window.__cmpTCModel;

      let s = this.feature?.descriptionLegal?.replace("Vendors can:", "")

      if ( s ) {
        s = s.replace(/(\r\n|\n|\r)/gm, "")
        s = s.replace("N.B. ", " ")

        this.formattedDescriptions = s.split("* ").filter( ( e : any ) => Boolean((<String>e).length) );
      }

      // console.log(s);

    }

    expandCollapseClick() {
      // console.log("expandCollapseClick()")
      if ( ! this.expanded )
        this.collapseClass = 'collapseButton collapseButtonRotatedDown';
      else
        this.collapseClass = 'collapseButton collapseButtonRotatedUp';
      this.expanded = ! this.expanded;
    }

}

